class DWPluginConfigurations {

    /**
     *
     * @param {array} pluginConfigurations
     */
    constructor(pluginConfigurations = []) {

        const pluginConfigs = new Map()

        pluginConfigurations
            .forEach(({id, data}) => {
                pluginConfigs.set(id, data)
            })

        this._pluginConfigurations = pluginConfigs
    }

    getConfigValue(pluginId, field, defaultValue = null) {

        if (this._pluginConfigurations.has(pluginId)) {

            if (field === undefined) {
                return {data: this._pluginConfigurations.get(pluginId)}
            }

            try {
                const value = this._pluginConfigurations.get(pluginId)[field]

                return value !== undefined ? value : defaultValue
            }
            catch(ex) {
                return defaultValue
            }
        }

        return defaultValue
    }

}

export {DWPluginConfigurations}
